export default {
  "container": "_container_1wdxcn",
  "icon": "_icon_1wdxcn",
  "bar": "_bar_1wdxcn",
  "delete": "_delete_1wdxcn"
};
